<template>
  <div id="format">
    <Breadcrumb />
    <p class="sub-title prl70">Select Button Format</p>
    <div class="content middle collect mb50">
      <div class="cell">
        <!--  Start -->
        <div>
          <div class="container font14 dflex"
            :class="{ fcolumn: $store.getters.isVertical, frow: !$store.getters.isVertical }">
            <div class="row">
              <div class="col-xs-12 text-center mt30 inlineb mb30">
                <div class="inlineb p10 w100">
                  <div ref="printMe" class="inlineb">
                    <BlackJackPanel />
                  </div>
                </div>
              </div>
            </div>

            <div class="row prl70" :class="{ pt100: $store.getters.isVertical }">
              <div class="col-xs-12 text-center">
                <el-radio :class="'format format-' + item.label" v-for="item in buttonFormatSet[type]" :key="item.label"
                  v-model="buttonFormat" :label="item.label">
                  <div class="mlr20 inlineb">
                    <div class="border inlineb svgb">
                      <i class="iconfont3" :class="item.img"></i>
                      <!-- <img class="radio-side font20 click" :src="item.img"/> -->
                    </div>
                    <p class="name-f">
                      {{ item.title }}
                    </p>
                  </div>
                </el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nav-footer mywhite font16">
      <span class="white click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="white click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>

      <span class="orange click inlineb w10" @click="next()">
        NEXT <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import Breadcrumb from "./Panel/Breadcrumb";
import BlackJackPanel from "./Panel/BlackJackPanel";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";

export default {
  name: "s2",
  components: {
    Breadcrumb,
    BlackJackPanel
  },
  mixins: [artworkToProductMixin],
  data() {
    return {
      type: null,
      buttonFormatSet: {
        blackjack: [
          { label: "square", title: "Square Buttons", img: "icon-square_buttons" },
          { label: "round", title: "Round Buttons", img: "icon-round_buttons" },
          { label: "oval", title: "Oval Buttons", img: "icon-oval_buttons" },
          { label: "rectangle", title: "Rectangular Buttons", img: "icon-rectangle_buttons" },
        ]
      },
    };
  },

  methods: {
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },

    next() {
      this.$store.commit("getProductCode");
      this.$router.push({ path: "/collection/product/" + this.routeParamArtworkId });
    },
    back() {
      this.$store.commit("getProductCode");
      this.$router.push({ path: "/collection/format/" + this.routeParamArtworkId });
    },
  },

  created: function () {
    if (!this.$store.state.artwork.type) {
      alert("Please go to the start page");
      this.$router.push({ path: "/collection/" });
    }
    this.$parent.headerB();
    this.$parent.headerNoBg();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 3.5;
    //read from store
    this.type = this.$store.state.artwork.type;
  },
  computed: {
    buttonFormat: {
      get: function () {
        return this.$store.state.artwork.buttonFormat;
      },
      set: function (newValue) {
        if (newValue == 'round' || newValue == 'square') {
          if (this.$store.state.artwork.layoutStyle != 'iconOnly' && this.$store.state.artwork.layoutStyle != 'socket') {
            this.$store.state.artwork.layoutStyle = 'iconOnly';
            this.$store.state.artwork.alignment = "topcenter";
          }
          if (this.$store.state.artwork.rightLayoutStyle != 'iconOnly' && this.$store.state.artwork.rightLayoutStyle != 'socket') {
            this.$store.state.artwork.rightLayoutStyle = 'iconOnly';
            this.$store.state.artwork.rightAlignment = "topcenter";
          }
          if (this.$store.state.artwork.tripleRightLayoutStyle != 'iconOnly' && this.$store.state.artwork.tripleRightLayoutStyle != 'socket') {
            this.$store.state.artwork.tripleRightLayoutStyle = 'iconOnly';
            this.$store.state.artwork.tripleRightAlignment = "topcenter";
          }
        }
        this.$store.state.artwork.buttonFormat = newValue;
        this.$store.commit("getContent");
        this.$store.commit("getRightContent");
        this.$store.commit("getTripleRightContent");
      },
    },
  },
};
</script>

<style lang="css" scoped>
.nav-footer {
  border-top: 1px solid #ccc;
}
</style>
